import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../App';
import './AppLayout.css';

function formatAmount(n) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n || 0);
}

export default function AppLayout({ children }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <div className="layout">
      {/* ── Header ── */}
      <header className="header">
        <div className="header-inner">
          <Link to="/shop" className="header-logo">
            <img src="/logo.png" alt="FastBox" className="header-logo-img"
              onError={e => { e.target.style.display = 'none'; }} />
            <span className="header-logo-text">Fast Box</span>
          </Link>

          <nav className="header-nav">
            <Link to="/shop" className={`nav-link${location.pathname === '/shop' ? ' active' : ''}`}>
              <i className="fa-solid fa-store" />
              <span>Boutique</span>
            </Link>
            <Link to="/orders" className={`nav-link${location.pathname === '/orders' ? ' active' : ''}`}>
              <i className="fa-solid fa-box-open" />
              <span>Mes commandes</span>
            </Link>
          </nav>

          <div className="header-right">
            {user && (
              <>
                <div className="user-pill">
                  <img
                    src={user.avatar
                      ? `https://cdn.discordapp.com/avatars/${user.discordId}/${user.avatar}.png?size=32`
                      : '/logo.png'}
                    alt="Avatar"
                    className="user-avatar"
                    onError={e => { e.target.src = '/logo.png'; }}
                  />
                  <span className="user-name">{user.characterName || user.username}</span>
                  <span className="user-balance">{formatAmount(user.balance)}</span>
                </div>
                <button className="logout-btn" onClick={handleLogout}>
                  <i className="fa-solid fa-right-from-bracket" />
                  Déconnexion
                </button>
              </>
            )}
          </div>
        </div>
      </header>

      {/* ── Contenu ── */}
      <main className="main-content">
        {children}
      </main>

      {/* ── Footer ── */}
      <footer className="footer">
        <p>© 2026 NexaRP — Fast Box · Toutes les transactions sont sécurisées par Fleeca Bank</p>
      </footer>
    </div>
  );
}
